export const READING_PAGE_IMAGE_WIDTH = 480
export const READING_PAGE_IMAGE_HEIGHT = 300
export const COMPREHENSION_IMAGE_WIDTH = 368
export const COMPREHENSION_IMAGE_HEIGHT = 207
